import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { compactVerify } from '../jws/compact/verify.js';
import jwtPayload from '../lib/jwt_claims_set.js';
import { JWTInvalid } from '../util/errors.js';
export function jwtVerify(_x, _x2, _x3) {
  return _jwtVerify.apply(this, arguments);
}

function _jwtVerify() {
  _jwtVerify = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(jwt, key, options) {
    var _a, verified, payload, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return compactVerify(jwt, key, options);

          case 2:
            verified = _context.sent;

            if (!(((_a = verified.protectedHeader.crit) === null || _a === void 0 ? void 0 : _a.includes('b64')) && verified.protectedHeader.b64 === false)) {
              _context.next = 5;
              break;
            }

            throw new JWTInvalid('JWTs MUST NOT use unencoded payload');

          case 5:
            payload = jwtPayload(verified.protectedHeader, verified.payload, options);
            result = {
              payload: payload,
              protectedHeader: verified.protectedHeader
            };

            if (!(typeof key === 'function')) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", _objectSpread({}, result, {
              key: verified.key
            }));

          case 9:
            return _context.abrupt("return", result);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _jwtVerify.apply(this, arguments);
}